import app from '../app';
import { formatUserLevel, formatOrderStatus, formatPrice } from './formatters';

const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;

let ysfReady = false;
let ysfSDK;

export default function createKefu(sdk = function() {}) {
  ysfSDK = sdk;

  ysfSDK('onready', () => {
    ysfReady = true;

    if (app.env.debug) {
      console.log('ysf ready');
    }
  });

  return { openKefu };
}

function openKefu({ product, order, own } = {}) {
  if (!own) {
    app.gotoLogin();
    return;
  }

  new Promise((resolve, reject) => {
    if (!ysfReady) {
      throw new Error('打开客服失败');
    }

    const { uid, username, nickname, realName, level, head } = own;

    ysfSDK('config', {
      uid,
      name: `${nickname} 【${realName} | ${formatUserLevel(level)}】`,
      mobile: username,
      data: JSON.stringify([{ key: 'avatar', value: head }]),
      robotShuntSwitch: 1,
      success: () => resolve(),
      error: () => reject(new Error('打开客服失败')),
    });
  })
    .then(
      () =>
        new Promise((resolve, reject) => {
          let productInfo;

          if (order) {
            const { orderId, expressNo, orderSkuVos, orderStatus } = order;

            productInfo = {
              title: `订单号：${orderId}`,
              desc: `物流单号：${expressNo}`,
              picture: orderSkuVos[0] && orderSkuVos[0].photo,
              note: `订单状态：${formatOrderStatus(orderStatus)}`,
              url: `${ADMIN_URL}#/order/detail/${orderId}`,
              show: 0,
            };
          } else if (product) {
            const { name, keyword, images, type, msPrice, realPrice } = product;

            productInfo = {
              title: name,
              desc: keyword,
              picture: images[0],
              note: `￥${formatPrice(type === 3 ? msPrice : realPrice)}`,
              url: window.location.href,
              show: 1,
            };
          }

          if (!productInfo) {
            resolve();
            return;
          }

          productInfo.success = () => resolve();
          productInfo.error = () => reject(new Error('打开客服失败'));

          ysfSDK('product', productInfo);
        })
    )
    .then(() => {
      // window.location.href = ysfSDK('url');
      ysfSDK('open');
    })
    .catch(error => app.showTips('error', error.message));
}
